export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/bird.99dc8372-ddadac.svg";